/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from "react";
import PropTypes from "prop-types";
import Alert from "../../../widgets/Alert/Alert";
import { MESSAGES } from '../../../../constants/APP_CONSTANTS';

export default class CollectionAlerts extends React.Component {
    static get propTypes() {
        return {
            collection: PropTypes.object,
            notes: PropTypes.array,
            resources: PropTypes.array
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            alerts: [],
            hasOM: false,
            has3P: false
        };
    }

    hasOM(printAdminComponent) {
        return printAdminComponent.oms && printAdminComponent.oms.find(resource => resource.resourceType === "OM");
    }

    has3P (printAdminComponent) {
        return printAdminComponent.oms && printAdminComponent.oms.find(resource => resource.resourceType === "PearsonRights" || resource.resourceType === "PearsonCCC");
    }

    hasBluePrint (notes) {
        return !!notes.find(note => note.body.includes(MESSAGES["book_has_blueprint_msg_part1"]));
    }

    getPrintRentals = (notes) => {
        const stringMatch = MESSAGES["print_rental_content_match"];
        return notes.map(note => {
            if (note.body && note.body.includes(stringMatch)) {
                const percent = note.body.match(/: (\d*)%/)[1];
                const isbn = note.body.match(/(?:ISBN )(.*)/)[1];

                return { percent, isbn };
            }
            return null;
        }).filter(obj => !!obj);
    };

    render() {
        const { printAdminComponent, notes } = this.props;
        const alerts = [];

        const hasOM = this.hasOM(printAdminComponent);
        const has3P = this.has3P(printAdminComponent);
        let hasBluePrint = this.hasBluePrint(notes);
        const hasPrintRentals = !!(printAdminComponent.printRentalDrvs && printAdminComponent.printRentalDrvs.length > 0);

        if (hasOM && has3P) {
            alerts.push({
                type: "primary",
                message:
                    "Original Material (OM) and Third Party Material (3P) are included in this Collection."
            });
        } else if (hasOM) {
            alerts.push({
                type: "primary",
                message:
                    "Original Material (OM) is included in this Collection."
            });
        } else if (has3P) {
            alerts.push({
                type: "primary",
                message:
                    "Third Party Material (3P) is included in this Collection."
            });
        }

        if (hasBluePrint) {
            alerts.push({
                type: "primary",
                message:
                    `NCCER BLUEPRINT INCLUDED: File name: ${this.props.collection.isbn}_blueprint`
            });
        }

        if (hasPrintRentals) {
            let printRentals = this.getPrintRentals(notes);
            let isbns = [];
            printAdminComponent.printRentalDrvs.map(drv => isbns.push(drv.isbn));
            let rentals = {};
            printRentals.reverse();
            printRentals.forEach(printRental => {
                rentals[printRental.isbn] = printRental.percent;
            });

            isbns.map(isbn =>alerts.push({
                type: "primary",
                message: `Print Rental Pilot Content used in this Collection: ${rentals[isbn]}% of source ISBN ${isbn}`
            }));
        }

        return alerts.map((alert, index) => (
            <Alert key={index} message={alert.message} type={alert.type} />
        ));
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainerComponents/CollectionAlerts.js